<template>
    <div class="modal fade" :id="modalId" data-backdrop="static" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
        <div v-if="title" class="modal-header">
            <h5 class="modal-title">{{title}}</h5>
            <button type="button" class="close" @click="$emit('dismiss')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <slot>
                <!-- Add components to this slot -->
            </slot>
        </div>
        </div>
    </div>
    </div>
</template>

<script>

import componentMixin from './component-mixin.js'

export default {
    mixins:[
        componentMixin
    ],
    data(){
        return {
            modalId:this.makeRandomId(),
        };
    },
    props:{
        title:{
            type:String,
            default:"",
        },
        shown:Boolean,
    },
    watch:{
        shown: function(newVal, oldVal){
            if (newVal){
                $(`#${this.modalId}`).modal('show');
            } else {
                $(`#${this.modalId}`).modal('hide');
            }
        }
    },
    mounted(){
        if (this.shown){
            $(`#${this.modalId}`).modal('show');
        }
    }
}
</script>

<style>

</style>
